export default {
    add_call_task: "Add calling task",
    add_to_funnel: "Add to funnel",
    add_to_funnel_came_and_repeated: "Add to funnel 'Came and repeated'",
    all_days: "All days",
    all_doctors: "All doctors",
    all_plan_treatment_doctors: "All doctors treatment plans",
    amo_deal_id: "Amo deal ID",
    api_key: "API key",
    applications_and_appeals: "Applications and appeals",
    are_you_sure_you_want_to_delete_task: "Are you sure you want to delete task?",
    ask_for_confirmation_response_from_patient: "Ask for confirmation response from patient",
    attach_file: "Attach file",
    authorized: "Authorized",
    auto: "Automatic",
    binotel: "Binotel",
    binotel_integration: "Binotel integration",
    binotel_integration_instructions: "In order to integrate Dentist Plus with Binotel you need: <br>1. to create account in Binotel<br>2. write to Binotel techsupport asking them to set up the following webhook for <b>API CALL SETTINGS</b> and <b>API CALL COMPLETED</b>:<br><span class='text-primary'>{url}</span><br>3. in the field below, specify the users from the clinic staff who will use the binotel functionality:",
    binotel_internal: "Binotel internal number",
    binotel_key: "Binotel key",
    binotel_secret: "Binotel secret",
    button_title: "Button title",
    call_from_patient: "Call from patient",
    call_from_phone: "Call from phone",
    call_noun: "Call",
    callee: "Callee",
    came_and_repeated: "Came and repeated",
    canban_mode: "Funnel mode",
    cancel_sending: "Cancel sending",
    cancellation_response: "Cancellation response",
    change_status: "Status of call",
    client_comment: "Client comment",
    close_the_integration_for_this_branch: "Close the integration for this branch",
    confirmation_response: "Confirmation response",
    copied: "Copied",
    copy_to_clipboard: "Copy to clipboard",
    create_application_on_call: "Create an application on call in application and appeals automatically",
    create_card_automatically: "Create card automatically",
    create_lead: "Create a lead",
    create_lead_on_incoming_message_if_no_lead: "Create a lead on incoming messages in whatsapp if there is no active lead until the status \"Recorded\"",
    create_lead_on_incoming_messages: "Create a lead on incoming messages",
    created_visit_administrator: "Administrator who created the visit",
    crm: "CRM",
    curator_assigned: "Curator assigned",
    deadline: "Deadline",
    deal: "Deal",
    do_not_create_duplicates: "Do not crete duplicates",
    do_not_create_duplicates_on_call: "Do not create duplicates for calls if there is already an active application until the status \"Recorded\"",
    do_not_create_duplicates_on_messages: "Do not create duplicates for incoming messages if there is already an active application until the status \"Recorded\"",
    do_not_create_lead_if_patient_exists: "Do not create a lead if the patient is already in the database",
    do_not_show_anymore: "Do not show anymore",
    domain: "Domain",
    during_incoming: "When incoming",
    during_outcoming: "For outgoing",
    feedback: "Feedback",
    feedbacks: "Feedbacks",
    finish_authorization: "Complete authorization",
    follow: "Follow",
    for_came_from_lead_funnel: "For those who came from leads funnel",
    for_came_on_first_visit: "For those who came on first visit",
    for_came_to_consultation: "For those who came to consultation",
    for_incoming: "For incoming",
    for_missed: "For missed",
    for_outcoming: "For outcoming",
    funnel_came_and_repeated: "Funnel: Came and repeated",
    generate_key: "Generate key",
    get_gift: "Get gift",
    get_sms: "Get sms",
    has_overdue_tasks: "Has overdue tasks",
    has_tasks: "Has tasks",
    has_today_task: "Has today tasks",
    has_visit: "Have a visit",
    if_lead_has_no_responsible_then_assign_to_this_person_on_first_save: "If lead has no responsible person set, then assign to this person on first save",
    inprogress: "In progress",
    insert_script_one_time_instruction: "Put this script in <head> section",
    insert_widget_button_instruction: "Place this code where you want the button to appear",
    instruction: "Instruction",
    integration_key: "Integration key",
    internal_phone: "Internal phone",
    last_30_days: "Last 30 days",
    last_thirty_days: "Last thirty days",
    lead_channel: "Lead channel",
    leave_comment: "Leave a comment",
    manually_selected_user: "Manually selected user",
    mark_as_completed: "Mark as completed",
    mark_as_finished: "Mark as finished",
    mark_as_in_progress: "Mark as in progress",
    message_template: "Message template",
    message_templates: "Message templates",
    messenger: "Messenger",
    messengers: "Messengers",
    move_to_funnel_came_and_repeated: "Move to funnel 'Came and repeated'",
    my_deals: "My deals",
    my_tasks: "My tasks",
    no_rating: "No rating",
    nobody: "Nobody",
    one_patient_one_lead: "One patient - one lead",
    open_whatsapp: "Open whatsapp",
    outgoing_calls_through: "Outgoing calls through",
    overdue: "Overdue",
    patient_already_has_active_deal: "Patient already has an active deal: {dealId}",
    patient_curator: "Patient supervisor",
    patient_deposit_sum: "Patient deposit amount",
    patient_has_no_future_visits_continue: "No future visits found for the patient. Do you want to continue?",
    patient_lost: "The patient is lost",
    patient_not_derived: "Patient not found",
    patient_not_derived_from_phone: "Call from {phone} - patient not found",
    patient_stopped_treatment: "The patient interrupted treatment",
    paused: "On pause",
    pbx: "PBX",
    pbx_integration_instructions: "To integrate Dentist Plus with PBX, you need to: <br>1. create an account in PBX<br>2. in your PBX personal account, in the Webhooks section, add the url:<br><span class='text-primary'>{url}</span><br>3. in the field below, specify the users from the clinic staff who will use the pbx functionality, and fill in the remaining fields below:",
    phone_max_instructions: "Before starting authorization, make sure that a MAX messenger account is already registered on the phone number through the mobile application.",
    plan_treatments: "Plan treatments",
    planned: "Planned",
    publish: "Publish",
    published: "Published",
    rating: "Rating",
    recall: "Call date",
    recall_on_lead: "Recall on lead '{title}'",
    record_myself: "Submit",
    record_on_visit: "Create a visit",
    recorded_on_visit: "Recorded on visit",
    request_qr: "Request a QR",
    responsible: "Responsible person",
    responsible_on_call: "Responsible on call",
    responsible_on_other_leads_not_created_manually: "Responsible for other leads not created manually",
    responsible_type_in_task: "Type of person responsible for the task",
    responsible_user: "Responsible user",
    resume_mailing: "Resume mailing",
    sales_funnel: "Sales funnel",
    search_by_name: "Search by name",
    search_by_phone: "Search by phone",
    see_later: "See later",
    select_user: "Select user",
    send_feedback_link_to_patient: "Send the patient a link to review",
    send_receipt_to_patient: "Send the patient a receipt",
    sent_error: "Send error",
    show_call_card: "Show call card",
    sipuni: "Sipuni",
    sipuni_integration_instructions: "To integrate Dentist Plus with Sipuni you need: <br>1. create an account in Sipuni<br>2. in the Sipuni personal account in the API section, generate an integration key, click 'activate the service' in the 'Call to number' and 'PBX events' items, and also in the 'PBX events' item specify the 'URL of the receiving script':<br>< span class='text-primary'>{url}</span><br>3. in the field below, indicate users from the clinic staff who will use the sipuni functionality, and fill in the remaining fields below:",
    sms_code: "SMS code",
    soon: "Soon",
    stage: "Stage",
    stages: "Stages",
    start_period: "Starting date",
    system_number: "Number in the system",
    task: "Tasks",
    task_date: "Task date",
    task_type: "Task type",
    tasks_and_calls: "Tasks and calls",
    tilda_integration_instructions: "To receive webhooks from forms on your Tilda website and generate leads in the dentist-plus system, you need the following:<br />1. In your Tilda account, go to Site Settings → Forms → Webhook<br/>2. In the Webhook URL field, enter <span class='text-primary'>{url}</span><br>3. In the API METHOD field select 'HEADER', in the 'Field name' fill in 'API-KEY', and in the 'Api key' field itself copy the key that you can generate below.<br />4. In advanced settings, activate 'Send Cookies'.<br />5. The following fields from the forms will be automatically filled in the dentist-plus system: <b>name, phone, email, comment</b>.",
    treatment_plan_created_2: "Treatment plan created",
    treatment_plan_finished: "Treatment plan completed",
    treatment_plan_signed: "Treatment plan signed",
    treatment_refused: "Treatment refused",
    treatment_started: "Treatment started",
    turn_on_chat_panel: "Turn on chat panel",
    uis: "UIS",
    uis_integration_instructions: "To integrate Dentist Plus with UIS you need: <br>1. create an account in UIS<br>2. in the UIS personal account, open the settings of the desired user (for example, Administrator) and in the API Functionality Access section, activate the 'Use API Key' setting<br/>3. In the 'Notifications' menu item, create 2 notifications: for waiting response and the end of a conversation. In both cases, activate the HTTP notification method and in the URL field specify the link:<br><span class='text-primary'>{url}</span><br>4. in the field below, indicate users from the clinic staff who will use the uis functionality, and fill in their virtual numbers (for receiving and initializing calls):",
    undergoing_treatment: "Undergoing treatment",
    unpublish: "Unpublish",
    use_common_name_for_documents_for_all_branches: "Use common name for documents for all branches",
    user_add_id: "Author",
    view: "View",
    visit_confirm: "Visit confirm",
    visit_doctor: "Doctor visit",
    visit_source: "Visit source",
    without_tasks: "Without tasks",
    write_in_messenger: "Write in messenger",
    you_also_can_use_link: "You can also use the link to the form directly"
}
